import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'parameters',
  templateUrl: './parameters.component.html'
})
export class ParametersComponent implements OnInit {
  constructor() {

  }


  ngOnInit(): void {

  }

}